module.exports = __webpack_public_path__ + "static/img/bg-logo@2x.bd409297.png";